import type { FileUploadStatus } from "./types";

export const FILE_UPLOAD_STATE_STATUS = {
  UPLOADING: "uploading",
  COMPLETED: "completed",
  ERROR: "error",
  NONE: "none",
} as const satisfies Record<string, FileUploadStatus>; // assert we use correct values
